var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('el-checkbox',{staticClass:"checkbox",on:{"input":_vm.handleInput},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._v(" "+_vm._s(_vm.$t(`FORM.FIELDS.${_vm.name}.TITLE`))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }